import ApiService from './ApiService';

export default class ApproveApi extends ApiService {
    constructor() {
        super('system');
    }

    getAllBikeApprove(payload) {
        return this.get('bikes-approve', payload);
    }

    getResionByBikeId(bikeId) {
        return this.get(`bikes-approve-resions/${bikeId}`, { page: -1 });
    }

    approveBikes(payload) {
        return this.post('admin-approve-bikes', payload);
    }

    getAllCouponApprove(payload) {
        return this.get('coupon-approve-list', payload);
    }

    approveCoupons(payload) {
        return this.post('coupons-approve', payload);
    }
}
